import { useTranslation } from 'react-i18next';
import { S, DataCard, formatCHF, formatDate } from '../regureStyles';

const AgingTabContent = ({ aging, invoices, handleRecordPayment, paying }) => {
  const { t } = useTranslation();
  const headers = [
    t('screens.invoicing.agingColClient'),
    t('screens.invoicing.agingColInvoice'),
    t('screens.invoicing.agingColAmount'),
    t('screens.invoicing.agingColDueDate'),
    t('screens.invoicing.agingColAction'),
  ];
  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: S.textPrimary, marginBottom: 16 }}>{t('screens.invoicing.agingTitle')}</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 28 }}>
        {aging.map(a => (
          <DataCard key={a.label}>
            <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8 }}>{a.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: a.amount > 0 ? a.color : S.textMuted }}>{formatCHF(a.amount)}</div>
            <div style={{ fontSize: 12, color: S.textMuted, marginTop: 4 }}>
              {t('screens.invoicing.agingInvoiceCount', { count: a.count })}
            </div>
          </DataCard>
        ))}
      </div>
      <div style={{ fontSize: 15, fontWeight: 700, color: S.textPrimary, marginBottom: 14 }}>{t('screens.invoicing.agingOverdueClients')}</div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {headers.map(h => (
              <th
                key={h}
                style={{
                  padding: '10px 14px',
                  textAlign: 'left',
                  fontSize: 11,
                  fontWeight: 700,
                  color: S.textMuted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.8,
                  borderBottom: `2px solid ${S.borderLight}`,
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {invoices
            .filter(i => i.status === 'overdue')
            .map((inv, idx) => (
              <tr key={inv.id} style={{ borderBottom: `1px solid ${S.borderLight}`, background: idx % 2 === 0 ? '#fff' : S.bgCard }}>
                <td style={{ padding: '12px 14px', fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{inv.client}</td>
                <td style={{ padding: '12px 14px', fontSize: 13, color: S.burgundy, fontWeight: 600 }}>{inv.id}</td>
                <td style={{ padding: '12px 14px', fontSize: 13, fontWeight: 600, color: '#ef4444' }}>{formatCHF(inv.amount)}</td>
                <td style={{ padding: '12px 14px', fontSize: 13, color: '#ef4444', fontWeight: 600 }}>{formatDate(inv.dueDate)}</td>
                <td style={{ padding: '12px 14px' }}>
                  <button
                    onClick={() => handleRecordPayment(inv)}
                    disabled={paying === inv._id}
                    style={{
                      padding: '6px 12px',
                      background: S.bgCard,
                      border: `1px solid ${S.borderLight}`,
                      borderRadius: 6,
                      fontSize: 11,
                      fontWeight: 600,
                      color: S.textSecondary,
                      cursor: 'pointer',
                    }}
                  >
                    {paying === inv._id ? t('screens.invoicing.saving') : t('screens.invoicing.actionRecordPayment')}
                  </button>
                </td>
              </tr>
            ))}
          {invoices.filter(i => i.status === 'overdue').length === 0 && (
            <tr>
              <td colSpan={5} style={{ padding: '24px', textAlign: 'center', color: S.textMuted, fontSize: 13 }}>
                {t('screens.invoicing.agingNoOverdue')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AgingTabContent;
